import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { Loader } from "@/components/common/Loader";
import { useAlertsAccess } from "./useAlertsEnabled";

/** Pages that belong to alerts (the outreach editor and its templates) open only where alerts do; anyone else goes Home. */
export function AlertsOnly({ children }: { children: ReactNode }) {
  const access = useAlertsAccess();

  if (access === "checking") {
    return (
      <div className="flex justify-center py-6">
        <Loader size={32} />
      </div>
    );
  }
  if (access === "disabled") return <Navigate to="/" replace />;

  return <>{children}</>;
}
